const config = {
  API_CALL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:5000/api"
      : "https://foodable-node.herokuapp.com/api/",
  SERVER_URL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:5000"
      : "https://foodable-node.herokuapp.com",
};

module.exports = config;
